import { createContext } from "react";

interface UserContextType {
    user:{
        roles:string
    }
}
export const UserContext = createContext<UserContextType | null>(null);